<template>
	<DjBox id="job-skills-box" data-test="job-skills-section" class="pt-5 md:pt-8 pl-5 md:pl-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-4">{{ title }}</h3>
		<ul>
			<li
				v-for="(item, index) in data"
				:key="index"
				:class="[
					'block mr-5' /* Moved the mr-5 to the parent list item */,
					index != data.length - 1 ? 'border-b border-dj-gray-light pb-5 mb-5' : '',
				]"
			>
				<div class="flex items-center justify-between mb-3">
					<span class="font-medium max-w-[240px] md:max-w-[220px]">
						{{ item.skill[locale] }}
					</span>
					<span class="text-sm text-dj-gray">{{ item.level }} / 5</span>
				</div>

				<DjProgressBar :level="item.level" :max="5" />
			</li>
		</ul>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import DjProgressBar from "~/components/DjProgressBar.vue";

type sData = {
	skill: {
		en: string;
		hu: string;
		ro: string;
	};
	level: string;
};

export default defineComponent({
	name: "DjBoxSkills",
	components: { DjProgressBar },
	props: {
		title: {
			type: String,
			default: "title",
		},
		data: {
			type: Array as PropType<sData[]>,
			required: true,
		},
		locale: {
			type: String,
			default: "hu",
		},
	},
});
</script>
